(function () {
  'use strict';

  angular
    .module('lead.bulk.status')
    .directive('leadBulkStatus', leadBulkStatus);

  leadBulkStatus.$inject = [];

  function leadBulkStatus() {
    var directive = {
      bindToController: true,
      controller: 'leadBulkStatusCtrl',
      controllerAs: 'vm',
      template: require('../lead.bulk.status/lead.bulk.status.html'),
      link: link,
      restrict: 'EA',
      scope: {
        query: '=query',
        onCancel: '&onCancel',
        onSave: '&onSave',
      },
    };
    return directive;

    function link(scope, element, attrs) {}
  }
})();
